module.exports = __webpack_public_path__ + "static/assets/f7019cbc4a2716adaf0842f6a41f1c79.svg";